import Image from 'next/image'

import Flex from '@ilg-totallymoney/ui/components/Flex'
import theme from '@ilg-totallymoney/ui/theme'

interface TableItemImageProps {
    cmsImageUrl: string
    name: string
}

const TableItemImage = ({ name, cmsImageUrl }: TableItemImageProps) => (
    <Flex
        width={['107px', '172px']}
        height={['52px', '86px']}
        justifyContent={['center', 'flex-start']}
    >
        <Image
            src={cmsImageUrl}
            alt={`${name} loan`}
            width={0}
            height={0}
            quality={65}
            sizes={`(max-width: ${theme.small}px) 107px, 172px`}
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
            }}
        />
    </Flex>
)

export default TableItemImage
